import { Outlet, NavLink } from "react-router-dom";
import BottomNav from "@/components/BottomNav";
import { InstallPrompt } from "@/components/InstallPrompt";
import { useAuth } from "@/lib/auth";
import { LogOut, Settings as SettingsIcon, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useMemo } from "react";
import { useKeyboardShortcuts } from "@/hooks/use-keyboard-shortcuts";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function ClassicShell() {
  const { user, signOut } = useAuth();
  useKeyboardShortcuts();

  const userInitials = useMemo(() => {
    if (!user) return '?';
    const meta = user.user_metadata;
    if (meta?.name) return (meta.name as string).charAt(0).toUpperCase();
    if (meta?.full_name) return (meta.full_name as string).charAt(0).toUpperCase();
    if (user.email) return user.email.charAt(0).toUpperCase();
    return '?';
  }, [user]);

  return (
    <div className="min-h-screen bg-background pb-20 pb-sticky-footer">
      <div className="max-w-lg mx-auto px-4">
        <div className="flex justify-end items-center gap-2 py-2">
          <InstallPrompt />
          {user && (
            <>
              <div
                title={user.email || ''}
                className="w-8 h-8 rounded-full bg-primary/20 border border-primary/30 flex items-center justify-center text-xs font-bold text-primary cursor-default"
              >
                {userInitials}
              </div>

              {/* Hamburger menu with SettingsIcon */}
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button size="icon" variant="ghost" className="h-8 w-8" title="Menu">
                    <Menu className="h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-44">
                  <DropdownMenuItem asChild>
                    <NavLink to="/settings" className="flex items-center gap-2 w-full">
                      <SettingsIcon className="h-4 w-4" />
                      Settings
                    </NavLink>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem
                    className="text-destructive focus:text-destructive gap-2"
                    onClick={() => signOut()}
                  >
                    <LogOut className="h-4 w-4" />
                    Sign out
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </>
          )}
        </div>
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
